import Head from 'next/head'
import Image from 'next/image'
import Nav from '@/components/Nav';
import Footer from '@/components/Footer';
import FeaturedPosts from '@/components/posts/FeaturedPosts';
import groq from 'groq';
import client from '../sanity_client';
import {urlFor} from '../sanity_image';
import {toHTML} from '@portabletext/to-html';
import React, { useState } from "react";
import Banner from '@/components/PageBanner';
import RegistrationForm from '@/components/RegistrationForm';

export default function Registration({pageContent, siteSettings}:any) {

  return (
    <>
      <Head>
        <title>The Line of Sight &#8480;</title>
      </Head>
      <Nav />
      <main className="row paper-id" data-paper-id="params['research_paper']">
        <Banner bannerHeading={pageContent[0].title} bannerSubHeading={pageContent[0].banner_sub_heading} bannerImage={urlFor(pageContent[0].banner_image).width(1920).url()} />
        <div className="col-12">
          <div className="container">
            <div className="row">
            </div>
            <div className="row">
              <div className="col-12">
                <RegistrationForm adminEmails={siteSettings[0].admin_emails} />
              </div>
            </div>
          </div>
        </div>
      </main>
      <Footer />
    </>
  )
}

export async function getServerSideProps() {
  const pageContent = await client.fetch(groq`*[_type == "registrationPage"]`);
  const siteSettings = await client.fetch(groq`*[_type == "siteSettings"]`);
  return {
    props: {
      pageContent: pageContent,
      siteSettings: siteSettings
    }
  }
}
